/**
 * Utilitários para máscaras e formatação de dados sensíveis
 */

/**
 * Mascara CPF para exibição (oculta dados sensíveis)
 */
export const maskCpf = (cpf: string | undefined): string => {
  return cpf ? '***.***.***-**' : '-';
};

/**
 * Mascara telefone para exibição (oculta dados sensíveis)
 */
export const maskPhone = (phone: string | undefined): string => {
  return phone ? '+** (**) *****-****' : '-';
};

/**
 * Formata telefone para exibição normal (WhatsApp Corporativo)
 */
export const formatPhone = (phone: string | undefined): string => {
  if (!phone) return '-';
  
  // Formatar: 5541999999999 -> +55 (41) 99999-9999
  const cleaned = phone.replace(/\D/g, '');
  
  if (cleaned.length === 13) {
    return `+${cleaned.slice(0,2)} (${cleaned.slice(2,4)}) ${cleaned.slice(4,9)}-${cleaned.slice(9)}`;
  }
  
  return phone; // Retorna original se não conseguir formatar
};

/**
 * Remove formatação de telefone (para envio ao backend)
 */
export const cleanPhone = (phone: string): string => {
  return phone.replace(/\D/g, '');
};

/**
 * Remove formatação de CPF (para envio ao backend)
 */
export const cleanCpf = (cpf: string): string => {
  return cpf.replace(/\D/g, '');
};
